/**
 * App Header Component
 *
 * TASK-086: Refactored to integrate AccountIndicator
 * TASK-168: Added Settings navigation button
 *
 * Main navigation header displaying:
 * - Kielis branding/logo
 * - Settings button (TASK-168)
 * - Account indicator with user info and logout
 */

import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Settings, Search } from 'lucide-react';
import AccountIndicator from '../AccountIndicator';

const AppHeader: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation('navigation');
  const isSettingsPage = location.pathname === '/settings';
  const isSearchPage = location.pathname === '/search';

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Kielis Branding */}
          <div className="flex items-center">
            <h1 className="text-2xl font-bold text-gray-900">
              Kielis <span className="text-kielis-gold">✦</span>
            </h1>
          </div>

          {/* Right Side: Search + Settings + Account */}
          <div className="flex items-center gap-2">
            {/* Search Button - TASK-265 */}
            <button
              onClick={() => navigate('/search')}
              className={`
                p-2 rounded-lg transition-colors
                ${isSearchPage
                  ? 'bg-blue-50 text-blue-600'
                  : 'text-slate-500 hover:text-blue-600 hover:bg-blue-50'
                }
              `}
              title={t('search', 'Search')}
              aria-label={t('search', 'Search')}
            >
              <Search size={20} />
            </button>

            {/* Settings Button - TASK-168 */}
            <button
              onClick={() => navigate('/settings')}
              className={`
                p-2 rounded-lg transition-colors
                ${isSettingsPage
                  ? 'bg-blue-50 text-blue-600'
                  : 'text-slate-500 hover:text-blue-600 hover:bg-blue-50'
                }
              `}
              title={t('settings', 'Settings')}
              aria-label={t('settings', 'Settings')}
            >
              <Settings size={20} />
            </button>

            {/* Account Indicator - TASK-086 */}
            <AccountIndicator />
          </div>
        </div>
      </div>
    </header>
  );
};

export default AppHeader;